/**
 * 사용자 포럼 API (docs/features/33-user-forum.md) — 글 · 답변 · 좋아요 · 신고 · 비밀글 · 논리 삭제/복구(관리자).
 * 누가 무엇을 볼 수 있는지는 서버가 정한다. 화면은 받은 것을 그릴 뿐이다.
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';
const ROOT = `${BASE_URL}/forum`;
const enc = encodeURIComponent;
const kindOf = (target) => (target === 'reply' ? 'replies' : 'posts');

/** { admin, unseen: { replies, reports?, secretOpen? } } */
export async function me() { return (await axios.get(`${ROOT}/me`)).data; }
/** 닉네임을 바꾼 직후 — 서버가 세션을 다시 읽어 포럼의 작성자 이름을 바꾼다 */
export async function refreshMe() { return (await axios.post(`${ROOT}/me/refresh`)).data; }
/** { total, items } — view: all · mine · reported · secret · deleted, sort: latest · likes · unanswered */
export async function listPosts(params) { return (await axios.get(`${ROOT}/posts`, { params })).data; }
export async function getPost(id) { return (await axios.get(`${ROOT}/posts/${enc(id)}`)).data; }
export async function createPost(body) { return (await axios.post(`${ROOT}/posts`, body)).data; }
export async function editPost(id, body) { return (await axios.put(`${ROOT}/posts/${enc(id)}`, body)).data; }
export async function addReply(postId, body) { return (await axios.post(`${ROOT}/posts/${enc(postId)}/replies`, { body })).data; }
export async function editReply(id, body) { return (await axios.put(`${ROOT}/replies/${enc(id)}`, { body })).data; }
export async function toggleLike(target, id) { return (await axios.post(`${ROOT}/${kindOf(target)}/${enc(id)}/like`)).data; }
export async function report(target, id, { reason, note }) { return (await axios.post(`${ROOT}/${kindOf(target)}/${enc(id)}/report`, { reason, note })).data; }
export async function remove(target, id, reason) { return (await axios.post(`${ROOT}/${kindOf(target)}/${enc(id)}/delete`, { reason })).data; }
export async function restore(target, id, reason) { return (await axios.post(`${ROOT}/${kindOf(target)}/${enc(id)}/restore`, { reason })).data; }
/** action: keep(문제없음) · hide(숨긴 채) · delete(삭제) */
export async function resolveReports(target, id, action, reason) { return (await axios.post(`${ROOT}/${kindOf(target)}/${enc(id)}/resolve`, { action, reason })).data; }
